import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import {
	IAssigneeTeam,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';
import { Subject } from 'rxjs';

import { AuDirectivesModule } from '@shared/directives/au-directives.module';
import { MatMenuModule } from '@angular/material/menu';
import { InputTypeSelectComponent } from '@shared/ui-components/au-assignee-select/components/input-type-select/input-type-select.component';
import { InputTypeBlockComponent } from '@shared/ui-components/au-assignee-select/components/input-type-block/input-type-block.component';
import { AssigneeOptionsListComponent } from '@shared/ui-components/au-assignee-select/components/assignee-options-list/assignee-options-list.component';
import { AssigneeOrganizationOption } from '@shared/ui-components/au-assignee-select/au-assignee-select.types';

export type AssigneeSelectType = 'input' | 'block';

@Component({
	selector: 'au-assignee-select',
	templateUrl: './au-assignee-select.component.html',
	styleUrls: ['./au-assignee-select.component.scss'],
	imports: [
		AuDirectivesModule,
		MatMenuModule,
		InputTypeSelectComponent,
		InputTypeBlockComponent,
		AssigneeOptionsListComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuAssigneeSelectComponent {
	@Input() type: AssigneeSelectType = 'input';
	/* A label that will be used as a placeholder and
	move to top on focus same as material label.
	Will not be used if type==='input' */
	@Input() label: string;
	/* Placeholder can be used in addition to label */
	@Input() placeholder = 'Choose an option';
	@Input() options: AssigneeOrganizationOption[];
	@Input() disableTeamsSelection: boolean = true;
	@Input() value: IAssigneeTeam | IAssigneeUser;
	@Output() selectionChange = new EventEmitter<IAssigneeTeam | IAssigneeUser>();

	// TODO think about supporting formControls
	@Input() valid: boolean;

	blurEvent: Subject<void> = new Subject<void>();

	removeFocus(clickedOutside: boolean): void {
		if (clickedOutside) {
			this.blurEvent.next();
		}
	}

	selectOption(option: IAssigneeTeam | IAssigneeUser): void {
		this.selectionChange.emit(option);
	}
}
